export default ":host {\n  display: block;\n  width: 1024px;\n}";